import { render, staticRenderFns } from "./BasePaginator.vue?vue&type=template&id=1ac0d440&scoped=true"
import script from "./BasePaginator.vue?vue&type=script&lang=js"
export * from "./BasePaginator.vue?vue&type=script&lang=js"
import style0 from "./BasePaginator.vue?vue&type=style&index=0&id=1ac0d440&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac0d440",
  null
  
)

export default component.exports